
























































import { Component } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { Prop } from "vue/types/options";
import Vue from "vue";

@Component({
  props: {
    content: {} as Prop<Content>,
    detailed: {
      type: Boolean,
      default: true
    }
  }
})
export default class ContentListing extends Vue {
  [x: string]: any;

  loadAnimatedThumbnail = false;

  get loading(): boolean {
    return !this.content;
  }

  get animatedThumbnailStyle(): any {
    if (this.loadAnimatedThumbnail) {
      return {
        backgroundImage: "url('" + this.content.animated_thumbnail_url + "')"
      };
    } else {
      return {};
    }
  }

  get duration(): string {
    return (
      Math.floor(this.content.video_duration / 60) +
      ":" +
      ("0" + Math.floor(this.content.video_duration % 60)).slice(-2)
    );
  }

  get isNew(): boolean {
    const date = this.content.created_at;
    return true;
  }
}
